import { makeStyles } from "@mui/styles";
export default makeStyles((theme) => ({
  navbar: {
    boxShadow: "none",
    marginBottom: "20px",
  },
}));
